import { FC, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Box } from '@mui/material';
import useAuth from 'store/Auth/useAuth';

interface BaseLayoutProps {
  children?: ReactNode;
}

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to={'/login'} />;
  }

  if (isLoggedIn) {
    return <Navigate to={'/dashboard'} />;
  }
  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',
      }}
    >
      {children || <Outlet />}
    </Box>
  );
};

export default BaseLayout;
